import { render, staticRenderFns } from "./EvaluationThinkTank.vue?vue&type=template&id=cdb50bbc&scoped=true"
import script from "./EvaluationThinkTank.vue?vue&type=script&lang=js"
export * from "./EvaluationThinkTank.vue?vue&type=script&lang=js"
import style0 from "./EvaluationThinkTank.vue?vue&type=style&index=0&id=cdb50bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb50bbc",
  null
  
)

export default component.exports